import { FREELANCE_TASK_STATUS } from "src/constants"
import {
    EventNoteOutlined,
    MapRounded,
    Assessment,
    Settings,
    Person,
    Warehouse,
    FilterList,
} from "@mui/icons-material";

export const TABS =
    [
        {
            href: `/freelance_driver/tasks/create`,
            icon: Assessment,
            title: "Create task",
        },
        {
            href: "/freelance_driver/tasks",
            icon: EventNoteOutlined,
            title: "Tasks",
            children: FREELANCE_TASK_STATUS.map(status => {
                return {
                    title: status.text,
                    href: `/freelance_driver/${status.path}?status=${status.value}`,
                }
            })
        },
        {
            href: `/freelance_driver/orders/filter`,
            icon: FilterList,
            title: "filterOrders",
        },
        {
            href: "/freelance_driver/tasks/filter",
            icon: FilterList,
            title: "Tasks filter",
        },
        {
            href: `/freelance_driver/warehouse`,
            icon: Warehouse,
            title: "Warehouses",
        },
        {
            href: `/freelance_driver/zones`,
            icon: MapRounded,
            title: "Zones",
        },
        {
            href: `/freelance_driver/account`,
            icon: Person,
            title: "Account",
        },
        {
            // href: `/freelance_driver/settings`,
            icon: Settings,
            title: "Settings",
            children: [
                {
                    title: "Whatsapp Msgs",
                    href: `/freelance_driver/settings/whatsapp`
                },
                {
                    title: "Language",
                    href: `/freelance_driver/settings/language`
                }
            ]
        },
    ]
